export class IPCSstateMasterModel {
    stateId: string;
    shortName: string;
    name: string;
    isActive: string;
    displayOrder: string;
    createdDate: string;
    createdBy: string;
    modifiedDate: string;
    modifiedBy: string;
    isChecked?: boolean;
    isSelected?: boolean;
    isUpdate: string;
    encyStateId?: string;
}

export class IPCSMetrixTableModel {
    stateId: string;
    shortName: string;
    name: string;
    isActive: string;
    commissionRegistrationorCertification: string;
    agencyAssessments: string;
    nineOneOne: string;
    uSF: string;
    tRS: string;
    otherFees: string;
    otherRequirement: string;
    oustomerComplaintsHandledBy: string;
    isUpdate: string;
    sortComRegCert: string;
    sortAgencyAss: string;
    sortNineOneOne: string;
    sortUsf: string;
    sortTrs: string;
    sortOtherFees: string;
    sortOthReq: string;
    sortAgencyRegRest: string;
    sortNineEightEight: string;
    nineEightEight: string;
}

export class IPCSupdatesPageModel {
  pageIndex: any;
  pageSize: any;
  whereCondition: string;
  orderBy: string;
  keywordFilter: string;
  fromupdatesDateFilter: string;
  toupdatesDateFilter: string;
  userID: string;
  unreadonly: string;
  updatetype: string;
}

export class IPCSupdatesModel {
  updateId?: number;
  updateCategoryId?: number;
  updateCategoryName?: string;
  updateDate?: string;
  stateId?: number;
  stateName?: string;
  stateShortName?: string;
  updateType?: string;
  description?: string;
  matrixFundId?: number;
  matrixFundTitle?: string;
  fundFieldId?: number;
  fundFieldName?: number;
  displayOrder?: number;
  isActive?: boolean;
  isDeleted?: boolean;
  createdDate?: string;
  createdBy?: string;
  createdByName?: string;
  modifiedDate?: string;
  modifiedBy?: string;
  modifiedByName?: string;
  totalRecordCount?: string;
  isUpdateRequired?: boolean;
  clientCompanyId?: string;
  companyName?: string;
  actionCharges?: number;
  actionNotes?: string;
  actionTypeId?: number;
  companyUserUpdateModel?: any[];
  totalUserCount?: number;
  companyUserId?: number;
  totalCompanyCount?: number;
  companyEmailStatus?: string;
  isPushActionItem?: string;
}


export class IPCSMatrixModel {
    matrixId: number;
    stateId: number;
    stateName: string;
    createdDate: string;
    createdBy: string;
    createdByName: string;
    modifiedDate: string;
    modifiedBy: string;
    modifiedByName: string;
    registration?: string;
    regTitle?: string;
    listOfFund?: IPCSMatrixfundModel[];
    isUpdate?: string;
  }

  
  export class IPCSMatrixfundModel {
    matrixFundId: number;
    matrixId: number;
    title: string;
    applicable: string;
    currentAmount: string;
    administrativeRecovery: string;
    remit: string;
    billToCustomer: string;
    separateLineItem: string;
    addinfo: string;
    registration: string;
    otherRequirement: string;
    handledby: string;
    assementCatId: number;
    assementCatName: string;
    fundFieldId: number;
    displayOrder: number;
    isActive: boolean;
    isDeleted: boolean;
    createdDate: string;
    createdBy: string;
    createdByName: string;
    modifiedDate: string;
    modifiedBy: string;
    modifiedByName: string;
    totalRecordCount?: string;
    fundName: string;
    fundRefe: string;
    listOfOtherRequirement?: IPCSotherRequirementModel[];
    assessmentRequired: string;
  }
  
  export class IPCSotherRequirementModel {
    otherRequirementId: number;
    matrixFundId: number;
    title: string;
    description: string;
    displayOrder: number;
    createdDate?: string;
    createdBy?: string;
    modifiedDate?: string;
    modifiedBy?: string;    
  }
  

export class filterModel {
  pageNumber?: string;
  pageSize?: string;
  whereCondition?: string;
  orderBy?: string;
  keywordFilter?: string;
  stateID?: string;
  userID?: string;
  columnIndex?: string;
  productId?: number;
  actionTypes?: string;
  carrierCategories?: string;
  actionSatus?: string;
  listOfProduct?: string;
  emailKey?: string;
  isActionRequired?: boolean; 
  oprator?: string;
  fromDate?: string;
  toDate?: string;
  listOfType?: string;
  systemUserCondition?: string;
}

export class matrixPropery {
    proName: string;
    proValue: string;
}

export class carrierFilterModel {
  orderBy: string;
  keywordFilter: string;
  fromDate: string;
  todate: string;
  updateStatus: string;
  userID: number;
  ID: number;
  Status: number;
  filterFavourite: number;
  newCarrierID: number;
  carrierFilter: string;
}

export class carrierFilterModelV2 {
  orderBy: string;
  keywordFilter: string;
  fromDate: string;
  todate: string;
  updateStatus: string;
  userID: number;
  ID: number;
  Status: number;
  filterFavourite: number;
  newCarrierID: number;
  carrierFilter: string;
  pageNumber:number;
  pageSize:number;
}